const initialState = {
  stepCompleted: false,
  note: null,
}

export default function(state = initialState, action = {}) {
  switch (action.type) {
    case 'RESET_CLAIMS': {
      return initialState
    }

    case 'SET_NOTE': {
      return {
        ...state,
        note: action.payload.note,
        stepCompleted: true,
      }
    }

    default: {
      return state
    }
  }
}
